// Vuex
import { ActionTree } from 'vuex'

import { State } from './state'

import firebase from 'firebase/app'
import 'firebase/auth'

export default <ActionTree<State, unknown>>{
  setConnectionState({ commit }, newConnectionState): void {
    commit('setConnectionState', newConnectionState)
  },

  signOut(): void {
    firebase
      .auth()
      .signOut()
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .then((_message: unknown) => {
        // ...
        // console.log('Signed out!', message)
      })
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .catch((_error: { code: string; message: string }) => {
        // console.error('Failed to sign out', _error.code, _error.message)
      })
  },
}
